import React from "react";
import { useSelector } from "react-redux";
import MarketingNavigation from "../utils/components/MarketingNavigation";
import SMSMarketingStepper from "../utils/components/sms/SMSMarketingStepper";
import SMSUploadContainer from "../utils/components/sms/SMSUploadContainer";
import MarketingButtons from "../utils/components/MarketingButtons";
import MarketingToolTip from "../utils/components/MarketingToolTip";
import MarketingContainer from "../utils/components/MarketingContainer";
import template from "../utils/templates/sms_batch_template.csv";
import "../utils/styles/marketing-dashboard.css";

const SMSFileUpload = () => {
  const emailList = useSelector((state) => state.smsBatching.emailList);
  return (
    <MarketingContainer>
      <MarketingNavigation>
        <MarketingToolTip>
          <small className="text-black my-auto">
            <i className="fas fa-exclamation-circle mr-2 text-gray-600" />
            Questions on formatting?
            <i className="fas fa-file-download ml-2 mr-2" />
            <a style={{ color: "#5daf23" }} href={template} download>
              Download CSV template
            </a>
          </small>
        </MarketingToolTip>
      </MarketingNavigation>
      <SMSMarketingStepper />
      <SMSUploadContainer />
      <MarketingButtons
        prevButton="Previous"
        prevLink="/marketing/sms"
        nextButton="Continue"
        nextLink="/marketing/sms/review"
        required={!emailList}
      />
    </MarketingContainer>
  );
};

export default SMSFileUpload;
